import { Box, Grid } from '@material-ui/core';
import React from 'react';
import { BoxView } from '../Common.styled';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel.jsx';
import Button from '@material-ui/core/Button';
import collapseIcon from 'src/assets/images/SmallDownArrow.svg';
import { sizes } from 'src/styles/Media.styled';
import { StyledBoxContainer } from './TextWithClicks.styled';
import { logErrorToConsole } from 'src/utils/util';
const TextWithClicks = ({
    media,
    classes,
    leftTitle,
    editAction,
    editMarginLeft,
    typeNonTissue,
    typeEA,
    buttonImg,
    typeBundle,
    styleObj,
    alignItemsVal,
    justifyContentVal,
    fromReportPayment,
    marginLeft,
    screenType,
    isNewProduct,
    mlTissueNontissue,
    mlBundle,
    mrBundle,
    alignItems,
    item,
    collapseChildItem,
    showChildItem,
    isChildItem,
    fromPriceOverride,
    containerMarginLeft,
    mdPadding,
    isBundle
}) => {
    const winWidth = window.innerWidth;
    const isIpadWidth = winWidth >= 660 && winWidth <= 1200;
        const displayValue = (typeBundle || '')?.toUpperCase() === 'BUNDLE' && isIpadWidth ? 'B' : (typeBundle || '');
    return (
        <Grid
            container
            flexDirection={'row'}
            className={classes?.gridPadBottom}
             style={{ ...(styleObj && styleObj.labelStyle), flexWrap: 'nowrap' }}
            alignItems={alignItems}
            justifyContent={
                fromPriceOverride
                    ? 'space-between'
                    : justifyContentVal
                    ? justifyContentVal
                    : ''
            }
        >
            {leftTitle && (
                <Grid lg={7} md={8} sm={7} xs={media ? media.titleArea : 6}>
                    <CustomLabel
                        fWeight={'bold !important'}
                        fSize={'14px !important'}
                        color="#140F4B"
                     
                        opacity={1}
                        label={leftTitle}
                        letterSpacing={'-0.12px'}
                        marginLeft={marginLeft}
                       // wordBreak={item?.description && 'break-all'}
                        // style={{
                        //     wordBreak: 'break-all',
                        // }}
                        marginRight={item?.description ? '' : '18px'}
                    />
                </Grid>
            )}
            <Grid
                lg={5}
                md={4}
                sm={5}
                xs={media ? media.buttonnsArea : 6}
                style={{ width: '100%' }}
            >
                <StyledBoxContainer
                    display="flex"
                    flexDirection={'row'}
                    alignItems={alignItemsVal ? alignItemsVal : 'center'}
                    style={styleObj && styleObj.tagsStyle}
                    justifyContent={
                        justifyContentVal ? justifyContentVal : 'center'
                    }
                    // marginRight={
                    //     fromReportPayment &&
                    //     winWidth <= sizes.mobileDevice &&
                    //     isNewProduct &&
                    //     (typeNonTissue || typeEA || typeBundle) &&
                    //     editAction
                    //         ? typeNonTissue && typeNonTissue === 'NT'
                    //             ? '0px'
                    //             : typeNonTissue && typeNonTissue === 'T'
                    //             ? '0px'
                    //             : '0px'
                    //         : fromReportPayment &&
                    //           winWidth <= sizes.mobileDevice &&
                    //           isNewProduct &&
                    //           !(typeNonTissue || typeEA || typeBundle) &&
                    //           editAction &&
                    //           '-74px'
                    // }
                    marginLeft={containerMarginLeft}
                    mdPadding={mdPadding}
                >
                    {typeNonTissue && (
                        <BoxView
                            mr={'4px'}
                            bgColor={
                                typeNonTissue === 'NT' ? '#C2F1FD' : '#FFEBBF'
                            }
                            bgBorder={
                                typeNonTissue === 'NT'
                                    ? '0.5px solid #89d5e8ed'
                                    : '0.5px solid #FFAD00'
                            }
                            boxpadding={
                                screenType === 'desktop'
                                    ? '0px 8.3px'
                                    : '0px 4px'
                            }
                            ml={mlTissueNontissue}
                        >
                            <CustomLabel
                                fSize={'10px!important'}
                                letterSpacing={'0px !important'}
                                color={
                                    typeNonTissue === 'NT'
                                        ? '#04667E'
                                        : '#FFAD00'
                                }
                                pt={'2px!important'}
                                label={typeNonTissue}
                                fontFamily={'AvenirNextWorld Bold'}
                                opacity={'99%'}
                                lineHeight={'20px'}
                            />
                        </BoxView>
                    )}
                    {typeEA && (
                        <BoxView
                            bgColor="#EBEBEB"
                            bgBorder="none"
                            ml={'4px'}
                            bRadius={'10px'}
                            boxpadding="0 6px"
                        >
                            <CustomLabel
                                fSize={'11px!important'}
                                letterSpacing={'0px !important'}
                                color={'#140f4b'}
                                pt={'2px!important'}
                                label={typeEA}
                                fontFamily={'AvenirNextWorld Regular'}
                                lineHeight={'19px'}
                            />
                        </BoxView>
                    )}
                    {typeBundle && (
                        <>
                            <BoxView
                                bgColor="#F2EFFF"
                                bgBorder={'0.5px solid #C0B2FF'}
                                scrHeight={'18px'}
                                scrWidth={isIpadWidth ? '20px' : '59px'}
                                bRadius={'4px'}
                                mTop={'3px'}
                                mr={mrBundle}
                                ml={mlBundle}
                                boxpadding={'1px 4px 0'}
                                style={{ marginLeft: '6px' }}
                            >
                                <CustomLabel
                                    fSize={'10px!important'}
                                    letterSpacing={'0px !important'}
                                    color={'#654ADC'}
                                    fWeight={'bold!important'}
                                    label={displayValue}
                                    opacity={0.92}
                                    fontFamily={'AvenirNextWorld Bold'}
                                />
                            </BoxView>
                            {fromReportPayment &&
                                !isChildItem &&
                                item.isBundleItem && (
                                    <Box
                                        component={Button}
                                        style={{
                                            cursor: 'pointer',
                                            padding: '8px',
                                            minWidth: '36px',
                                            minHeight: '36px',
                                            marginRight: '5px',
                                            marginTop:'-8px',
                                            border: 'none',
                                            background: 'transparent',
                                        }}
                                        onClick={() => {
                                            try {
                                                if (item.isBundleItem && item.bundleItem?.length > 0) {
                                                    collapseChildItem(!showChildItem);
                                                }
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                    >
                                        <img
                                            id={`collapse-img-${item?.id ?? ''}`}
                                            src={collapseIcon}
                                            alt="down-arrow"
                                            style={{
                                                transform: !showChildItem
                                                    ? ''
                                                    : 'rotate(180deg)',
                                                pointerEvents: 'none',
                                            }}
                                            width="20px"
                                            height="20px"
                                        />
                                    </Box>
                                )}
                        </>
                    )}
                    {fromReportPayment && !isNewProduct ? null : (
                        <>
                            {editAction && winWidth <= sizes.smalDevice &&(
                                <Box
                                    component={Button}
                                    aria-controls="simple-menu-1"
                                    aria-hospopup="true"
                                    size="small"
                                    width="2rem!important"
                                    height="2rem!important"
                                    minWidth="2rem!important"
                                    minHeight="2rem!important"
                                    border="1px solid #EBEBEB"
                                    marginLeft={
                                        editMarginLeft ? editMarginLeft : '16px'
                                    }
                                    onClick={editAction}
                                    id={`edit-btn-${item?.id ?? ''}`}
                                >
                                    <img
                                        src={buttonImg}
                                        style={{ width: 24, height: 24 }}
                                    />
                                </Box>
                            )}
                        </>
                    )}
                </StyledBoxContainer>
            </Grid>
        </Grid>
    );
};

export default TextWithClicks;
